const OTHER_CONFIG_FILENAMES = [
  '.github/renovate.json',
  '.renovaterc',
  '.renovaterc.json',
  'renovate.json',
  'renovate.json5',
];

export const RENOVATE_CONFIG_FILENAMES = [
  '.github/renovate.json5',
  ...OTHER_CONFIG_FILENAMES,
];
